var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pop",
    {
      attrs: {
        animation: _vm.animationType || "fadeInRight",
        customClass: "detail-pop-wrap",
        enableAnimation: _vm.enableAnimation,
        showMask: false,
        allowClose: false,
      },
    },
    [
      _c("div", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        ref: "iframeWrap",
        staticClass: "detail-pop-container",
        attrs: { "loading-mask": "true" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }